import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

const PaginationLink = ({ path, pageIndex, currentPageIndex, isDisabled, ...originalProps }) => {
  const distanceFromCurrentlySelectedPage = Math.abs(currentPageIndex - pageIndex);
  let href = path;
  let rel = 'canonical';
  let hideLink = isDisabled;

  if (pageIndex > 1) {
    // Include page query param to all but the landing page
    href += `?page=${pageIndex}`;
    // For SEO purposes, do not include link to disabled items or pages far from current page
    hideLink = isDisabled || distanceFromCurrentlySelectedPage > 4;
  }

  if (pageIndex < currentPageIndex) {
    rel = 'prev';
  } else if (pageIndex > currentPageIndex) {
    rel = 'next';
  }

  return (
    <Link href={href} rel={rel} legacyBehavior>
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      {hideLink ? <span {...originalProps} /> : <a rel={rel} {...originalProps} />}
    </Link>
  );
};

PaginationLink.propTypes = {
  path: PropTypes.string.isRequired,
  pageIndex: PropTypes.number.isRequired,
  currentPageIndex: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};

export default PaginationLink;
